import { bytesToString } from "@/utils/utils";
import {} from ".";
export function bytesLabelFormatter(dataPoint) {
    return dataPoint ? `${dataPoint.label}: ${bytesToString(dataPoint.value)}` : "No data";
}
export function bytesValueFormatter(value) {
    return bytesToString(value);
}
